import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';
import { toast } from 'sonner';
import { Loader2, ArrowLeft, Mail } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success('Si el email existe, recibirás un correo en breve');
    } catch (err) {
      // Por seguridad mostramos el mismo mensaje siempre
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Card className="bg-card border-border">
          <CardContent className="p-8">
            <Link
              to="/login"
              className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-primary mb-6 transition-colors"
              data-testid="back-to-login"
            >
              <ArrowLeft className="h-4 w-4" />
              Volver al login
            </Link>

            <div className="mb-6">
              <h1 className="text-3xl font-bold text-foreground mb-2">Recuperar contraseña</h1>
              <p className="text-sm text-zinc-400">
                Ingresá tu email y te mandamos un link para crear una nueva contraseña.
              </p>
            </div>

            {sent ? (
              <div className="space-y-4 text-center" data-testid="forgot-success-block">
                <div className="mx-auto w-16 h-16 rounded-full bg-emerald-500/10 flex items-center justify-center">
                  <Mail className="h-8 w-8 text-emerald-400" />
                </div>
                <h2 className="text-xl font-semibold text-foreground">Revisá tu email</h2>
                <p className="text-sm text-zinc-400">
                  Si <strong className="text-foreground">{email}</strong> está registrado, te llegó un correo con instrucciones.
                </p>
                <p className="text-xs text-zinc-500">
                  El link es válido por 1 hora. Revisá la carpeta de spam si no lo ves.
                </p>
                <Link to="/login">
                  <Button variant="outline" className="w-full mt-4">Volver al login</Button>
                </Link>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="tu@email.com"
                    required
                    className="bg-zinc-800/50 border-zinc-700 focus:border-primary h-12"
                    data-testid="forgot-email-input"
                  />
                </div>
                <Button
                  type="submit"
                  className="w-full h-12 bg-primary font-bold uppercase tracking-wide"
                  disabled={loading}
                  data-testid="forgot-submit-button"
                >
                  {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
                  Enviar link de recuperación
                </Button>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
